import { useState, type FormEvent } from "react";

export type FormStatus = "idle" | "loading" | "success" | "error";

export function useFormSubmit(submitAddr: string) {
  const [status, setStatus] = useState<FormStatus>("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get("website_alt") as string)?.trim() ?? "";

    if (honeypot) {
      setStatus("success");
      setErrorMsg("");
      form.reset();
      return;
    }

    setStatus("loading");
    setErrorMsg("");

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key === "website_alt") return;
        params.append(key, value as string);
      });

      const res = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText) as Record<string, unknown>;
      } catch {
        parsed = null;
      }

      const meta = (parsed?.meta as Record<string, unknown>) ?? {};
      const code = parsed?.code as string | undefined;
      const success = res.ok && code === "OK";

      if (success) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setErrorMsg(
          (meta.message as string) ||
            (meta.detail as string) ||
            (parsed?.message as string) ||
            "Penghantaran gagal. Sila cuba lagi."
        );
      }
    } catch {
      setStatus("error");
      setErrorMsg("Ralat rangkaian. Sila cuba lagi.");
    }
  };

  return { status, errorMsg, handleSubmit, reset: () => setStatus("idle") };
}